import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import { isInstanceOf } from '../../../../helpers/types';
import { TaxReport } from './tax-report.model';

export class TaxReportCollection  extends  AbstractReport {

    mapTaxesFees(value) {
        if (!Array.isArray(value) || !isInstanceOf(TaxReport, value[0])) {

            value = TaxReport.factory(value);
        }

        return value;
    }

    setTaxes(value) {

        return this.mapTaxesFees(value);
    }

    setFees(value) {

        return this.mapTaxesFees(value);
    }

    setTaxesTotal(value) {

        return !isInstanceOf(TaxReport, value) ? new TaxReport(value) : value;
    }

    setFeesTotal(value) {

        return !isInstanceOf(TaxReport, value) ? new TaxReport(value) : value;
    }

    setGrandTotal(value) {

        return !isInstanceOf(TaxReport, value) ? new TaxReport(value) : value;
    }
}
AccessorsMutatorsDecorator(
    'id',
    'taxes',
    'taxes_total',
    'fees',
    'fees_total',
    'grand_total',
)(TaxReportCollection);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/financial/tax-report-collection.model.js